import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { PageLoader } from '../components/PageLoader';

export function RequireAuth({ component }) {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <PageLoader label="Redirecting to login..." />,
  });
  return <Component />;
}
